import React from "react";
import {IconButton, ListItemText} from "@mui/material";
import {DownloadLink} from "../../gen/api";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

type Props = {
  downloadLink: DownloadLink
}

function FormLink({downloadLink}: Props) {

  return (
      <>
        <a href={downloadLink.link} target="_blank" rel="noopener noreferrer">
          <IconButton color="primary">
            <ArrowRightIcon/>
          </IconButton>
        </a>
        <ListItemText secondary={downloadLink.formName}/>
      </>
  );
}

export default FormLink;